import React, { Component } from 'react';
import { observer } from 'mobx-react';
import UnitGrammarsForm from './UnitGrammarsForm';
import UnitItemListService from '../../../services/UnitItemListService';
import UnitFormService from '../../../services/UnitFormService';

class UnitGrammarsFormContainer extends Component {
  unitFormService = new UnitFormService();

  componentWillMount() {
    this.unitFormService.handleLoad(this.props.unitId, this.props.moduleId);
  }

  render() {
    return (
      <UnitGrammarsForm
        onSubmit={this.unitFormService.handleSubmit}
        onChange={this.unitFormService.form.setValue}
        onReset={this.unitFormService.form.reset}
        values={this.unitFormService.form.getValues()}
        errors={this.unitFormService.form.errors}
        submitting={
          UnitItemListService.fetch.fetching ||
          this.unitFormService.fetch.fetching ||
          this.unitFormService.submit.fetching
        }
        isDirty={this.unitFormService.form.isDirty}
      />
    );
  }
}

export default observer(UnitGrammarsFormContainer);
